<template>
<!-- 头部 -->
  <div class="header">
    <div class="ri">
<!--     <el-button class="oldAcCard" type="text">进入旧版答题卡制作</el-button>-->
      <a href="https://ac.7net.cc/index.html" class="oldAcCard">进入旧版答题卡制作</a>
      <el-dropdown  @command="logout">
        <span type="text" class="userName">
          {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="le">
      <Logo @logoClick="getActiveMenu('reset')"></Logo>
    </div>
  </div>
</template>

<script>
  import UserApi from "@/services/user";
  import router from "@/router";
  import Logo from "@/views/components/Logo";
export default {
  name: 'Header',
  components:{ Logo },
  props: {
    msg: String
  },
  data(){
    return {
      userInfo: {}
    }
  },
  watch: {
    $route() {
      this.getActiveMenu()
    }
  },
  created() {
    this.getActiveMenu()
  },
  computed: {
    userName () {
      if (!this.userInfo.userPhone) {
        return ''
      }
      let userPhone = this.userInfo.userPhone
      let myphone = userPhone.substr(3, 4);
      const lphone = userPhone.replace(myphone, "****");
      return this.userInfo.userName || lphone
    }
  },
  methods:{
    getActiveMenu(reset) {
      const route = this.$route
      let { path } = route
      if (path.split('/').length > 2) {
        path = '/' + path.split('/')[1]
        if (path === '/exams') path = '/'
      }
      if (reset) this.$refs.elMenu.updateActiveIndex(path)
      this.activeMenu = path
    },
    logout() {
      UserApi.Exit().then(res => {
        this.$router.replace({
          path: '/login',
          query: {
            redirect: router.currentRoute.fullPath,
          },
        });
      })
    }
  },
  mounted() {
    UserApi.UserInfo({}).then(res => {
      this.userInfo = res.data || {};
      this.$store.dispatch('user/setUserInfo', res.data)
    }).catch(ex=>ex)
  }
}
</script>

<style scoped lang="scss">
.header{
  height:60px;
  line-height:60px;
  background: #fff;
  padding: 0 10%;
  .userName{
    /*colo*/
    font-size: 16px;
  }
  .ri{
    float: right;
    /*width:216px;*/
    height:36px;
    line-height: 36px;
    /*border:1px solid #dadada;*/
    /*background: #f8f9f9;*/
    text-align: center;
    /*border-radius: 20px;*/
    margin-top:8px;
    padding: 0 10px;
    .oldAcCard{
      display: inline-block;
      margin-right: 20px;
      text-decoration: none;
      color: #409EFF;
      font-size: 14px;
    }
  }
 
}
</style>
